interface Props {
  score: number;
  size?: "sm" | "md" | "lg";
}

export default function NutritionHealthScore({ score, size = "md" }: Props) {
  const clamped = Math.max(0, Math.min(100, score));
  const circumference = 2 * Math.PI * 40;
  const offset = circumference - (clamped / 100) * circumference;

  const color =
    clamped >= 70 ? "var(--xpn-color-success)"
    : clamped >= 40 ? "var(--xpn-color-warning)"
    : "var(--xpn-color-danger)";

  const dims = size === "sm" ? 60 : size === "lg" ? 160 : 100;
  const radius = size === "sm" ? 24 : size === "lg" ? 64 : 40;
  const strokeW = size === "sm" ? 4 : size === "lg" ? 8 : 6;
  const c = 2 * Math.PI * radius;

  return (
    <div className="xpn-health-score" style={{ width: dims, height: dims, position: "relative" }}>
      <svg width={dims} height={dims} viewBox={`0 0 ${dims} ${dims}`}>
        <circle
          cx={dims / 2}
          cy={dims / 2}
          r={radius}
          fill="none"
          stroke="var(--xpn-border-subtle)"
          strokeWidth={strokeW}
        />
        <circle
          cx={dims / 2}
          cy={dims / 2}
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth={strokeW}
          strokeLinecap="round"
          strokeDasharray={c}
          strokeDashoffset={c - (clamped / 100) * c}
          transform={`rotate(-90 ${dims / 2} ${dims / 2})`}
          style={{ transition: "stroke-dashoffset 0.6s ease" }}
        />
      </svg>
      <div
        style={{
          position: "absolute",
          inset: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: 700,
          fontSize: size === "sm" ? 14 : size === "lg" ? 32 : 20,
          color,
        }}
      >
        {clamped}
      </div>
    </div>
  );
}
